import { getFarmersList, getFarmerProfile, sendFarmerMessage, } from "../api-calls/data-layer";
export var generateBNDataLayerProvider = function (bnAPIUrl, accessToken) {
    var getFarmers = function () {
        return getFarmersList(bnAPIUrl, accessToken);
    };
    var getFarmer = function (farmerId) {
        return getFarmerProfile(bnAPIUrl, accessToken, farmerId);
    };
    var contactFarmer = function (farmerId, message) {
        return sendFarmerMessage(bnAPIUrl, accessToken, farmerId, message);
    };
    return {
        isReady: bnAPIUrl !== "" && accessToken !== "",
        getFarmers: getFarmers,
        getFarmer: getFarmer,
        contactFarmer: contactFarmer,
    };
};
//# sourceMappingURL=generateBNDataLayerProvider.js.map